export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 14;

export const PASSWORD_REQUIREMENTS = [
  {
    key: "length",
    label: `${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters`,
    test: (v) => v.length >= PASSWORD_MIN_LENGTH && v.length <= PASSWORD_MAX_LENGTH,
  },
  { key: "uppercase", label: "One uppercase letter (A-Z)", test: (v) => /[A-Z]/.test(v) },
  { key: "lowercase", label: "One lowercase letter (a-z)", test: (v) => /[a-z]/.test(v) },
  { key: "number", label: "One number (0-9)", test: (v) => /[0-9]/.test(v) },
  { key: "special", label: "One special character (!@#$...)", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const getPasswordRequirementStatus = (value = "") =>
  PASSWORD_REQUIREMENTS.map((r) => ({ key: r.key, label: r.label, met: r.test(value) }));

export const isPasswordValid = (value = "") => PASSWORD_REQUIREMENTS.every((r) => r.test(value));

export const getPasswordError = (value = "") => {
  if (!value) return "Password is required.";
  const unmet = PASSWORD_REQUIREMENTS.find((r) => !r.test(value));
  if (!unmet) return null;
  return unmet.key === "length"
    ? `Password must be ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} characters.`
    : `Password must contain ${unmet.label.toLowerCase()}.`;
};
